export interface CustomerState {
  isCustomer: number | null,
  stayCustomer: number | null
}

export const InitialState: CustomerState = {
  isCustomer: null,
  stayCustomer: null
}
